"use strict"
exports.__esModule = true;
exports.PenNibIconConfig = {
  name: 'PenNibIcon',
  height: 512,
  width: 512,
  svgPath: 'M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z',
  yOffset: 0,
  xOffset: 0,
};
exports.PenNibIcon = require('../createIcon').createIcon(exports.PenNibIconConfig);
exports["default"] = exports.PenNibIcon;